
import modifyTemplate from '#shared/util/modifyTemplate.js';

import defaultSidebar from '#themes/default/default/components/sidebar/sidebar.js';

import cHeader from '#themes/default/web/components/header/header.js';
import cPriceTable from '#themes/default/web/components/priceTable/priceTable.js';
import cProduct from '#themes/default/web/components/product/product.js';
import defaultTemplate from '#themes/default/default/components/sidebar/sidebar.html' with { type: 'html' };

import sidebarTemplate from './html/sidebar.html' with { type: 'html' };

const template = modifyTemplate(defaultTemplate, [{
	query: '.sidebar',
	position: 'replace',
	content: sidebarTemplate
}]);

export default {
	components: {
		cHeader,
		cPriceTable,
		cProduct
	},
	extends: defaultSidebar,
	computed: {
		title() {
			if (this.page.number === 0 || this.page.number === 1) {
				return this.t('sidebar_yourOrder');
			} else if (this.page.number === 3) {
				return this.t('confirmOrder_title');
			} else {
				return null;
			}
		}
	},
	template
};
